// src/components/ReferPatient.jsx
import React from "react";
import "./refer.css";
import referImg from "../Assets/refer.png";
import {HOSPITAL_URL} from "../../Service/AxiosConfig"

function ReferPatient() {
  return (
    <section className="refer-section">
      <div className="refer-bg">
        <img src={referImg} alt="Refer Patients" className="refer-img" />
        <div className="refer-content">
        
          <button onClick={() => window.open( HOSPITAL_URL, "_blank")} className="refer-btn">Refer Patients from <br /> Your Hospital</button>
        </div>
      </div>
    </section>
  );
}

export default ReferPatient;
